<div class="BannerIropsFlightInfo">
  <div class="BannerIropsFlightInfo-alert">
    <img alt="" src="../../../../assets/images/Alert-icon.svg" />
    <p class="fs-18px lh-32px fw-regular m-0" [innerHTML]="'bannerIropsFlight.yourFlightWasAffected' | translate"></p>
  </div>
  <div class="BannerIropsFlightInfo-footer">
    <div class="BannerIropsFlightInfo-message">
      <p class="fs-20px lh-28px fw-regular text-am-blue m-0">
        {{ 'bannerIropsFlight.continueWithCheckIn' | translate }}
      </p>
    </div>
    <div class="BannerIropsFlightInfo-buttons">
      <app-button
        theme="iropsRebrandingWhite"
        text="bannerIropsFlight.changeFlight"
        width="274px"
        height="80px"
        (amClick)="onChange()"
      ></app-button>
      <app-button
        theme="iropsRebrandingPink"
        text="continueCap"
        width="274px"
        height="80px"
        (amClick)="onContinue()"
      ></app-button>
    </div>
  </div>
</div>